<template>

  <Container type="card-full" v-loading="loading">
    <div slot="header">
    </div>
    <div class="split-line"></div>
    <div class="view-container">
      <div class="view-box">
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">类型</div>
            <div class="view-value">{{pjnotice.pjnoticetypedesc}}</div>
          </div>
        </div>
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">主题</div>
            <div class="view-content">{{pjnotice.pjnoticetitle}}</div>
          </div>
        </div>
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">同时发布到</div>
            <div>
              <el-checkbox-group v-model="checkList" style="color:#66ccff;">
                  <el-checkbox v-for="i in picrList" :key="i.picid" :label="i.piccode">
                    {{i.picname}}
                  </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">公告附件</div>
            <div v-if="appendList && appendList.length" class="view-filelist">
              <div v-for="(item,index) in appendList" :key="index" class="view-fileitem">
                <div class="view-filename" @click="downFile(item.appendurl)"><a :src="uploadAddr + item.appendurl">{{item.appendfilename}}</a>
                </div>
              </div>
            </div>
            <div v-else class="view-value">无</div>
          </div>
        </div>
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">采购文件</div>
            <div v-if="projectAppendList && projectAppendList.length" class="view-filelist">
              <div v-for="(item,index) in projectAppendList" :key="index" class="view-fileitem">
                <div class="view-filename" @click="downFile(item.appendurl)"><a :src="uploadAddr + item.appendurl">{{item.appendfilename}}</a>
                </div>
              </div>
            </div>
            <div v-else class="view-value">无</div>
            <span style="color: red; margin-left: 12px;">{{ +project.projectpfvisible === 1 ? '公告中可见' : '公告中不可见' }}</span>
          </div>
        </div>

        <!-- 变更公告提交审核后的审核状态/审核日志/确认函（放在内容之前，避免长公告把状态挤到页面底部） -->
        <template v-if="+pjnotice.pjnoticetype === 2 && noticeAudit.hasSubmit">
          <div class="split-line"></div>
          <div class="view-row">
            <div class="view-field" style="align-items: center;">
              <div class="view-label">状态</div>
              <div class="view-value" style="width: 400px;">
                <div>{{ noticeAuditStatusDesc }}</div>
                <el-button v-if="+noticeAudit.auditstatus === 1" type="primary" icon="el-icon-edit-outline" size="small"
                  style="margin-left: 28px;" @click="openNoticeAudit">审核</el-button>
                <el-button type="primary" icon="el-icon-message" size="small" style="margin-left: 10px;"
                  @click="auditLogListVisible = true">审核日志</el-button>
              </div>
            </div>
          </div>
          <div class="view-row" v-if="+noticeAudit.auditstatus === 3 && noticeAuditRejectDesc">
            <div class="view-field">
              <div class="view-label">驳回意见</div>
              <div class="view-value"
                style="width: auto; max-width: 900px; color: #f56c6c; white-space: pre-wrap;">{{ noticeAuditRejectDesc }}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">确认函</div>
              <div v-if="confirmLetterList && confirmLetterList.length" class="view-filelist">
                <div v-for="(item, index) in confirmLetterList" :key="index" class="view-fileitem">
                  <div class="view-filename" @click="downFile(item.appendurl)"><a
                      :src="uploadAddr + item.appendurl">{{ item.appendfilename }}</a>
                  </div>
                </div>
              </div>
              <div v-else class="view-value">无</div>
            </div>
          </div>
        </template>
        <div class="split-line"></div>
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">内容</div>
            <div class="view-text">
              <div v-html="pjnotice.pjnoticedesc" style="margin-top:-12px"></div>
            </div>
          </div>
        </div>
        
        <template v-if="project.projectjjbgstatus && +pjnotice.pjnoticetype === 3">
          <div class="split-line"></div>
          <div style="margin-left: 25px;">
            <div class="view-row">
          <div class="view-field">
            <div class="view-label">失败报告附件</div>
            <div v-if="bgAppendList && bgAppendList.length" class="view-filelist">
              <div v-for="(item,index) in bgAppendList" :key="index" class="view-fileitem">
                <div class="view-filename" @click="downFile(item.appendurl)"><a :src="uploadAddr + item.appendurl">{{item.appendfilename}}</a>
                </div>
              </div>
            </div>
            <div v-else class="view-value">无</div>
          </div>
        </div>
          <div class="view-row">
          <div class="view-field">
            <div class="view-label">失败报告内容</div>
            <div class="view-text">
              <div v-html="pjnotice.projectjjcontent" style="margin-top:-12px"></div>
            </div>
          </div>
          </div>
        </div>
        </template>
      </div>
    </div>
    <el-dialog title="审核日志" :visible.sync="auditLogListVisible" width="50%">
      <audit-log-list :auditLogList="noticeAuditLogList"></audit-log-list>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="审核" :visible.sync="noticeAuditVisible" width="720px"
      :modal-append-to-body="false">
      <div class="view-container">
        <div class="view-box">
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">审核意见</div>
              <div class="view-value" style="width: 380px;">
                <el-input type="textarea" :autosize="{ minRows: 5 }" :rows="5" v-model.trim="auditCheckdesc"
                  :maxlength="255" show-word-limit></el-input>
              </div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">上传确认函</div>
              <div class="file">
                <div class="uploadbtn">
                  <upload-btn @changed="setConfirmFile" text="上传确认函"></upload-btn>
                  <span style="color: red">（可选）</span>
                </div>
                <div v-if="auditAppendList.length" class="filelist">
                  <div v-for="(item, index) in auditAppendList" :key="index" class="fileitem">
                    <div class="name" @click="downFile(item.appendurl)">
                      <a :src="uploadAddr + item.appendurl">{{ item.appendfilename }}</a>
                    </div>
                    <div class="btn" @click="delConfirmFile(item)">
                      <span>删除</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label"></div>
              <div class="view-value">
                <vxe-button type="primary" class="vxe-btn" @click="submitNoticeAudit(1)" :loading="btnLoading">审核通过
                </vxe-button>
                <vxe-button status="danger" class="vxe-btn" @click="submitNoticeAudit(2)" :loading="btnLoading">审核不通过
                </vxe-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import E from 'wangeditor'
  import config from '../../assets/config'
  import uploadBtn from '../common/uploadBtn'
  import common from '@/mixin/common'
  import dayjs from 'dayjs'
  import AuditLogList from './auditLogList.vue'

  export default {
    name: "pjnoticeForm",
    mixins: [common],
    data () {
      return {
        pickerOptions: {
          disabledDate (time) {
            return time.getTime() <= Date.now() - 86400000
          }
        },
        projectAppendList:[],
        pjnotice: {},
        project: this.$route.params.form,
        pjnoticetypeList: [],
        appendList: [],
        type: Number(this.$route.params.type),
        btnLoading: false,
        editorContent: '',
        editor: '',
        picrList:[],
        checkList:[],
        bgAppendList: [],
        loading:false,
        // 变更公告审核（auditlogcode 30）
        noticeAudit: { hasSubmit: false, auditstatus: 0, list: [] },
        confirmLetterList: [],
        auditCheckdesc: '',
        auditAppendList: [],
        auditLogListVisible: false,
        noticeAuditVisible: false
      }
    },
    created () {
    },
    async activated () {
      await this.init()
      await this.getAppendList()
      if (this.$route.params.pjnoticeid) {
        await this.getModel()
        await this.getProjectModel()
      }
      await this.getPjnoticetypeList()

      await this.getPicrList()
      await this.getNoticeAuditInfo()
    },
    mounted () {
      // this.initEditor()
    },
    // watch: {
    //   $route (to, from) {
    //     to.name === 'pjnoticeForm'
    //   }
    // },
    filters: {},
    components: {uploadBtn, AuditLogList},
    computed: {
      uploadAddr () {
        return this.$store.getters.uploadAddr
      },
      noticeAuditStatusDesc () {
        if (!this.noticeAudit.hasSubmit) return ''
        const status = +this.noticeAudit.auditstatus
        if (status === 1) return '待审核'
        if (status === 2) return '通过'
        if (status === 3) return '驳回'
        if (status === 4) return '已作废，需重新提交审核'
        return ''
      },
      // 审核日志时间线（作废记录为内部状态标记，不在时间线展示）
      noticeAuditLogList () {
        return (this.noticeAudit.list || []).filter(i => +i.auditlogtype !== 3)
      },
      // 本轮驳回的意见（取最新一条驳回回复的审核意见）
      noticeAuditRejectDesc () {
        const list = this.noticeAudit.list || []
        for (let i = 0; i < list.length; i++) {
          const item = list[i]
          if (+item.auditlogtype === 2 && +item.auditresult === 2) {
            return item.auditlogcontent || ''
          }
        }
        return ''
      },
      appendfromtype () {
        let appendfromtype = ''
        if (this.pjnotice.pjnoticetype == '1') {
          appendfromtype = '12'
        } else if (this.pjnotice.pjnoticetype == '2') {
          appendfromtype = '13'
        } else if (this.pjnotice.pjnoticetype == '3') {
          appendfromtype = '14'
        } else if (this.pjnotice.pjnoticetype == '4') {
          appendfromtype = '15'
        }
        return appendfromtype
      }
    },
    deactivated () {
      this.$destroy()
    },
    methods: {
      async getAppendList() {
        let res = await request({
          method: "get",
          url: "/ywgl/append/getAppendListByFromId",
          params: {
            appendfromid: this.$route.params.projectid,
            appendfromtype: 20,
          },
        });
        this.bgAppendList = res;
    },
      async getModel () {
        this.loading = true
        this.pjnotice = await request({
          url: '/xmgl/pjnotice/getPJNoticeListById',
          method: "get",
          params: {pjnoticeid: this.$route.params.pjnoticeid,cosid:this.$store.getters.loginUser.cosid}
        })
        this.appendList = this.pjnotice.appendList
        this.editorContent = this.pjnotice.pjnoticedesc
        this.checkList = this.pjnotice.checkList
        this.loading = false
      },
      async getPicrList(){
        //获取接口
        let data = await request({
            url: '/xmgl/pjnotice/getPicrList',
            method: "get",
            params:{cosid:this.$store.getters.loginUser.cosid}
          })
          this.picrList = data
      },
      async getProjectModel () {
        this.project = await request({
          method: 'get',
          url: '/xmgl/project/findProjectById',
          params: {projectid: this.$route.params.projectid}
        })
        this.projectAppendList = this.project.appendList_zb
      },
      pjnoticetypeChange (val) {
        let name = ''
        let model = this.pjnoticetypeList.find(v => v.value == val)
        if (model) {
          name = model.label
        }
        this.pjnotice.pjnoticetitle ='关于'+ this.project.projectname +'(项目编号：'+ this.project.projectcode + ')'+'的' + name
      },
      async getPjnoticetypeList () {
        this.pjnoticetypeList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'pjnoticetype'}
        })
      },
      async init () {
        this.btnLoading = false
        // this.pjnoticetitle = '关于'+ this.project.projectname +'(项目编号：'+ this.project.projectcode + ')'+'的' + this.wmenu.wmenuname
      },
      delappend (file) {
        this.$confirm(`确定移除 ${ file.appendfilename }？`, '提示', {
          type: 'warning'
        }).then(() => {
          let index = this.appendList.findIndex((val) => val.appendfilename === file.appendfilename)
          this.appendList.splice(index, 1)
        }).catch(() => {
        })
      },
      async setfile (path, filename) {
        let append = {
          appendid: 0,
          appendfromid: 0,
          appendfromtype: this.appendfromtype,
          appendtype: '100',
          appendseq: this.appendList.length + 1,
          appendfilecode: '',
          appendfilename: filename,
          appendurl: path.replace(this.uploadAddr, '')
        }
        this.appendList.push(append)
      },
      // ===================== 变更公告审核（auditlogcode 30）=====================
      async getNoticeAuditInfo () {
        this.noticeAudit = { hasSubmit: false, auditstatus: 0, list: [] }
        this.confirmLetterList = []
        this.auditAppendList = []
        this.auditCheckdesc = ''
        if (!this.pjnotice.pjnoticeid || +this.pjnotice.pjnoticetype !== 2) {
          return
        }
        const res = await request({
          method: 'get',
          url: '/auditlog/getNoticeAuditStatus',
          params: {
            auditlogcosid: this.$store.getters.loginUser.cosid,
            auditlogfromid: this.pjnotice.pjnoticeid,
            auditlogcode: 30
          }
        })
        this.noticeAudit = (res && res.data) || { hasSubmit: false, auditstatus: 0, list: [] }
        if (this.noticeAudit.hasSubmit) {
          const list = await request({
            method: 'get',
            url: '/ywgl/append/getAppendListByFromId',
            params: {
              appendfromid: this.pjnotice.pjnoticeid,
              appendfromtype: 30
            }
          })
          this.confirmLetterList = list || []
          // 待审核时预填已上传的确认函，供审核人修改
          if (+this.noticeAudit.auditstatus === 1) {
            this.auditAppendList = (list || []).map(item => {
              return {
                appendid: 0,
                appendfromid: item.appendfromid,
                appendfromtype: '30',
                appendtype: item.appendtype || '100',
                appendseq: item.appendseq,
                appendfilecode: item.appendfilecode || '',
                appendfilename: item.appendfilename,
                appendurl: item.appendurl
              }
            })
          }
        }
      },
      async setConfirmFile (path, filename) {
        this.auditAppendList.push({
          appendid: 0,
          appendfromid: 0,
          appendfromtype: '30',
          appendtype: '100',
          appendseq: this.auditAppendList.length + 1,
          appendfilecode: '',
          appendfilename: filename,
          appendurl: path.replace(this.uploadAddr, '')
        })
      },
      delConfirmFile (file) {
        this.$confirm(`确定移除 ${file.appendfilename}？`, '提示', {
          type: 'warning'
        }).then(() => {
          let index = this.auditAppendList.findIndex((val) => val.appendfilename === file.appendfilename)
          this.auditAppendList.splice(index, 1)
        }).catch(() => {
        })
      },
      // 打开审核弹窗（仅待审核的变更公告）
      openNoticeAudit () {
        if (+this.noticeAudit.auditstatus !== 1) {
          this.$message.warning('该公告不是待审核状态！')
          return
        }
        this.auditCheckdesc = ''
        this.noticeAuditVisible = true
      },
      // 审核通过 auditresult=1 / 审核不通过(驳回) auditresult=2
      async submitNoticeAudit (auditresult) {
        if (+auditresult === 2 && !this.auditCheckdesc) {
          this.$message.warning('请输入审核意见！')
          return
        }
        this.btnLoading = true
        const data = await request({
          method: 'post',
          url: '/auditlog/addNoticeAudit',
          data: {
            auditlogcosid: this.$store.getters.loginUser.cosid,
            auditlogfromid: this.pjnotice.pjnoticeid,
            auditloguserid: this.$store.getters.loginUser.userid,
            auditresult: auditresult,
            auditlogcontent: this.auditCheckdesc,
            appends: this.auditAppendList
          }
        })
        this.btnLoading = false
        if (data && data.issuccess === 1) {
          this.noticeAuditVisible = false
          this.$message.success(+auditresult === 1 ? '审核通过' : '已驳回')
          this.close()
        } else {
          this.$message.error((data && data.msg) || '审核失败')
        }
      },
      async addOrEdit () {
        this.submitForm('ruleForm').then(async() => {
          if (this.$route.params.form) {
            this.pjnotice.pjnoticeprojectid = this.project.projectid
          }
          this.pjnotice.pjnoticedesc = this.editorContent
          this.pjnotice.appends = this.appendList
          this.pjnotice.pjnoticestatus = 0
          let data = await request({
            url: '/xmgl/pjnotice/addOrEdit',
            method: "post",
            data: this.pjnotice
          })
          if (data.issuccess === 1) {
            this.close()
            this.$message.success('保存成功')
          } else {
            this.$message.error('保存失败')
          }
        }).catch(() => {
        })
      },
      close () {
        console.log('this.$route.name', this.$route.name)

        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'pjnoticeIndex'})
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../styles/filelist";

  .view-container .view-box .view-row .view-field .view-label {
    width: 100px;
  }
  .view-container .view-box .view-row .view-field .view-content span{
    color:#66ccff;
  }
</style>

